import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import moment from 'moment';
import { Cache } from 'aws-amplify';
import { fetchProjectByRole, getProjectsJSON } from '../../store/actions/projects/projectsActions';
import { fetchProjectMembers } from '../../store/actions/projects/projectMembersActions';
import { refreshReports, 
  getMissingEntries, 
  getMissingEntriesByUser,
  getMissingEntriesByEmployee, 
  generateExportData } from '../../store/actions/reports/reportsActions';
import { WORK_HOURS } from '../../store/actions/timesheet/timesheetActions';
import { TEAM_LEADER, 
  PORTAL_ADMIN, 
  HR_ADMIN, 
  fetchSubordinates, 
  fetchUsers,  
  PROJECT_ADMIN} from '../../store/actions/users/usersActions';

import { drawTable } from '../../common/Utilities';
import PageTitle from '../../common/PageTitle';
import ExportReport from './ExportReport';

import '../../css/reports.css';

class MissingEntries extends Component {

  constructor(props) {
    super(props);
    
    this.buttonId = "generateReport";
    this.roleId = Cache.getItem('roleId');
    this.userId = Cache.getItem('userId');

    this.projectId = 0;

    this.startDate = new Date(moment().subtract(1, 'weeks').startOf('isoWeek'));
    this.endDate = new Date(moment().subtract(1, 'weeks').endOf('isoWeek'));
    this.startMaxDate = this.startDate;
    this.endMinDate = this.endDate;

    this.showTable = false;

    this.adminRoles = [PORTAL_ADMIN, HR_ADMIN, PROJECT_ADMIN];
  }

  componentDidMount() {
    this.props.fetchProjectByRole();

    if (this.roleId === TEAM_LEADER) {
      this.props.fetchSubordinates(this.userId);
    }
    else if (this.adminRoles.includes(this.roleId)) {
      this.props.fetchUsers({is_disabled: 0});
    }

    this.minDate = '';
    this.maxDate = new Date();
  }

  displayProjectDropDown = () => {

    let projectsJSON = this.props.getProjectsJSON({is_disabled: 0}) || [];

    /*
    const defaultValue   = {
      key: 0,
      value: 0,
      label: '--  SELECT ALL PROJECTS  --'
    }
    */

    projectsJSON.map(project => {
      ++project.key;
      return project; 
    })
    //projectsJSON.unshift(defaultValue);

    const selectClass = 'projectSelect';

    return (
      <Select
        className={selectClass}
        classNamePrefix={selectClass}
        size="sm"
        //defaultValue={defaultValue}
        onChange={(selectedOption ) => {
          this.projectId = +selectedOption.value || 0;

          if (this.projectId) {
            this.props.fetchProjectMembers(this.projectId);
          }
          this.changeMinDate();

          this.props.refreshReports();
        }}
        options={projectsJSON}
      />
    )
  }

  displayUserDropDown = () => {

    let usersJSON = [];
    let defaultValue = {};

    if (this.roleId === TEAM_LEADER) {
      const subordinates = this.props.users.subordinates || [];
      defaultValue = {
        key: 0,
        value: 0,
        label: '--  SELECT ALL SUBORDINATES  --'
      }
  
      usersJSON = [defaultValue, ...subordinates.map((user, key) => {
        const fullname = user.last_name + ', ' + user.first_name;
        return {
          key: ++key,
          value: +user.id,
          label: fullname
        }
      })];
    }
    else {
      const users = this.props.users.users || [];
      defaultValue = {
        key: 0,
        value: 0,
        label: '--  SELECT ALL USERS  --'
      }
  
      usersJSON = [defaultValue, ...users.map((user, key) => {
        const fullname = user.last_name + ', ' + user.first_name;
        return {
          key: ++key,
          value: +user.id,
          label: fullname
        }
      })];
    }

    const selectClass = 'subSelect';

    return (
      <Select
        className={selectClass}
        classNamePrefix={selectClass}
        size="sm"
        defaultValue={defaultValue}
        onChange={(selectedOption ) => {
          this.subordinateId = +selectedOption.value || 0;
          this.changeMinDate();

          this.props.refreshReports();
        }}
        options={usersJSON}
      />
    )

  }

  changeMinDate = () => {
    const projects = this.props.projects.projectsByRole;
    const projectId = this.projectId;
    
    if (projects && projects.length && projectId) {
      const project = projects.filter(project => project.id === projectId).pop();
      if (typeof(project) !== "undefined") {
        if (project.start_date) {
          this.minDate = new Date(project.start_date);
        }
      }
    }
  }

  displayDatepicker = () => {
    return (
      <Row>
        <Col xs={4} sm={4} md={4} lg={4} xl={4}>
          <DatePicker
            placeholderText="Start Date"
            minDate={this.minDate}
            maxDate={this.startMaxDate}
            onChange={(date) => {
              this.startDate = date;
              this.endMinDate = date;
              this.props.refreshReports();
            }} 
            selected={this.startDate}
            
          /> 
        </Col>
        <Col xs={6} sm={6} md={6} lg={6} xl={6}>
          <DatePicker
            placeholderText="End Date"
            minDate={this.endMinDate}
            maxDate={this.maxDate}
            onChange={(date) => {
              this.endDate = date;
              this.startMaxDate = date;
              this.props.refreshReports();
            }} 
            selected={this.endDate}
          /> 
        </Col>
      </Row>
    )
  }

  displayGenerateButton = () => {

    return (
      <Button
        id={this.buttonId}
        onClick={()=>{
          this.showTable = true;

          if (this.roleId === TEAM_LEADER) {
            this.props.getMissingEntriesByUser({
              start_date: this.startDate,
              end_date: this.endDate,
              subordinate_id: this.subordinateId || 0,
              user_id: this.userId
            })
          }
          else if (this.adminRoles.includes(this.roleId)) {
            this.props.getMissingEntriesByEmployee({
              start_date: this.startDate,
              end_date: this.endDate,
              employee_id: this.subordinateId || 0
            })
          } 
          else {
            this.props.getMissingEntries({
              project_id: this.projectId || 0,
              start_date: this.startDate,
              end_date: this.endDate,
              user_id: this.userId
            });
          }
         
        }}
      >
        Generate Report
      </Button>
    )
  }

  displayMissingEntries = () => {

    let tableData = {};
    tableData.headerClass = "align-center";
    tableData.headers =  [
      'Employee Name',
      'Missing Entries',
      'Team Leader'
    ];

    let keyValues = [
      'employee',
      'missingEntries', 
      'teamLeader'
    ];
    let exportData = [];

    tableData.body = [];
    let memberHours = [];

    let employees = [];
    if (this.roleId === TEAM_LEADER) {
      employees = this.props.users.subordinates;
    }
    else{
      employees = this.props.users.users;
    }
    if (employees && employees.length) {  
      employees.forEach(member => {
        if (member.id) {
          const firstName   = member.first_name || "";
          const middleName  = member.middle_name || "";
          const lastName    =  member.last_name || "";
          memberHours.push({ userId: member.id,
                              name: lastName +", " + firstName + " " + middleName,
                              missing_entries: [],
                              missing_hours: []
                            });
        }
      })
    } else {
      const projectMembers = this.props.projects.projectMembers;
      if (projectMembers && projectMembers.length) {
        projectMembers.forEach(project => {
          const member = project.user;
          if (member && member.id && !member.is_disabled) {
            const firstName   = member.first_name || "";
            const middleName  = member.middle_name || "";
            const lastName    =  member.last_name || "";
            memberHours.push({ userId: member.id,
                                name: lastName +", " + firstName + " " + middleName,
                                missing_entries: [],
                                missing_hours: []
                              });
          }
        })
      }
    }
    
    
    
    let missingEntries = this.props.reports.missingEntries;

    if (this.roleId === TEAM_LEADER) {
      missingEntries = this.props.reports.missingEntriesByUser;
    }
    else if (this.adminRoles.includes(this.roleId)){
      missingEntries = this.props.reports.missingEntriesByEmployee; 
    }
    
    if (missingEntries && missingEntries.length) {

      missingEntries.forEach(entry => {
        let teamLeaderName = '';
        if (entry && typeof(entry.team_lead) !== "undefined") {
          const teamLead = entry.team_lead;
          if (teamLead) {
            teamLeaderName = teamLead.first_name + " " + teamLead.last_name;
          }
        }
        memberHours.filter(member => member.userId === +entry.user_id )
          .forEach(member => {
            Object.assign(member, {team_leader: teamLeaderName});
            if (entry.missing_hours >= WORK_HOURS) {
              member.missing_entries.push(entry.time_entry_date)
            } else if (entry.missing_hours.toFixed(2) > 0) {
              member.missing_hours.push( { 
                date: entry.time_entry_date,
                hours: entry.missing_hours
              } )
            }

          })
      })

      let items = [];

      memberHours.forEach( member => {
        const missingEntries = member.missing_entries;

        let exportRow = {}

        if (missingEntries.length) {
          let row = [];
          
          let employeeName = member.name;
          let teamLeader = member.team_leader;
          let txtMissingEntries = '';

          row.push(employeeName);

          if (missingEntries.length) {
            let arrMissingEntries = [];

            let prevValue = '';
            let startValue = '';
            missingEntries.forEach((date) => {

              if (prevValue) {
                const start = moment(prevValue);
                const end = moment(date);
                 if (moment.duration(end.diff(start)).asDays() === 1) {
                  arrMissingEntries.pop();
                   if (!startValue) {
                     startValue = prevValue
                   } 

                   arrMissingEntries.push(moment(startValue).format('MMM DD') + " - " + moment(date).format('MMM DD, YYYY'))
                 } else {
                   startValue = '';
                   arrMissingEntries.push(moment(date).format('MMM DD, YYYY'));
                 }
               } else {
                arrMissingEntries.push(moment(date).format('MMM DD, YYYY'));
               }
               prevValue = date;
              
            })

            row.push(arrMissingEntries.map((missingTimeEntry, key) => (
              <div key={key}>
                { missingTimeEntry }
              </div>
            )));

            

            //for export file
            txtMissingEntries = arrMissingEntries.join(", ");

          } else {
            row.push("");
          }



          row.push(teamLeader);

          Object.assign(exportRow, {[keyValues[0]]: employeeName});
          Object.assign(exportRow, {[keyValues[1]]: txtMissingEntries});
          Object.assign(exportRow, {[keyValues[3]]: teamLeader});

          items.push(row);
          exportData.push(exportRow);
        }
      })

      if (items.length) {
        tableData.body = items;
      }
      else {
        tableData.body = null;
      }
    }
    else {
      tableData.body = null;
    }

    this.exportHeaders = tableData.headers;
    this.exportData = exportData;

    return drawTable(tableData, this.showTable);
  }

  generateExportButton = () => {
    if (!this.showTable || !this.exportData || !this.exportHeaders) {
      return '';
    }

    const data = generateExportData(this.exportHeaders, this.exportData);

    return (
      <ExportReport fileName="missing_entries" data={data} />
    )
  }

  render() {
    let dropDown = this.displayProjectDropDown();
    if (this.roleId === TEAM_LEADER || this.adminRoles.includes(this.roleId)) { 
      dropDown = this.displayUserDropDown();
    }

    return (
      <React.Fragment>
        <PageTitle pageName="Missing Entries" />
        <Row className="mt-3">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Row>
              <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                { dropDown }
              </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                { this.displayDatepicker() }
              </Col>
              <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                { this.displayGenerateButton() }
              </Col>
            </Row>
          </Col>
        </Row>
        
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            { this.displayMissingEntries() }
          </Col>
        </Row>
        <Row>
          <Col>
            { this.generateExportButton() }
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects,
  reports: state.reports,
  users: state.users
})

const mapDispatchToProps = (dispatch) => {
  return {
    getProjectsJSON: (...args) => dispatch(getProjectsJSON(...args)),
    fetchProjectByRole: (...args) => dispatch(fetchProjectByRole(...args)),
    getMissingEntries: (...args) => dispatch(getMissingEntries(...args)),
    getMissingEntriesByUser: (...args) => dispatch(getMissingEntriesByUser(...args)),
    getMissingEntriesByEmployee: (...args) => dispatch(getMissingEntriesByEmployee(...args)), 
    fetchProjectMembers: (...args) => dispatch(fetchProjectMembers(...args)),
    refreshReports: (...args) => dispatch(refreshReports(...args)),
    fetchSubordinates: (...args) => dispatch(fetchSubordinates(...args)),
    fetchUsers: (...args) => dispatch(fetchUsers(...args))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MissingEntries))